import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { usePayTokenPriceLatest } from '@ui/features/Trade/hooks/usePayTokenPriceLatest';
import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import { Nullable } from '@ui/types/utility';
import BigNumber from 'bignumber.js';

import { valueStyle } from './styles';

type InitialCollateralProps = {
  position: Position;
  marketPrice?: Nullable<BigNumber>;
};

export const InitialCollateral = (props: InitialCollateralProps) => {
  if (Object.prototype.hasOwnProperty.call(props, 'marketPrice')) {
    return <InitialCollateralValue {...props} />;
  }

  return <InitialCollateralWithHooks {...props} />;
};

const InitialCollateralWithHooks = ({
  position,
  ...props
}: InitialCollateralProps) => {
  const marketPrice = usePayTokenPriceLatest(position.collateralToken);

  return (
    <InitialCollateralValue
      position={position}
      marketPrice={marketPrice}
      {...props}
    />
  );
};

const InitialCollateralValue = ({
  position,
  marketPrice,
  ...props
}: InitialCollateralProps) => {
  if (!marketPrice) {
    return <></>;
  }

  const initialCollateral = position.getCollateralUsd(marketPrice);

  return (
    <AmountUsd
      css={valueStyle}
      value={initialCollateral}
      data-cy-value={initialCollateral}
      {...props}
    />
  );
};
